import { render, staticRenderFns } from "./AddCandidate.vue?vue&type=template&id=1d8fa503"
import script from "./AddCandidate.vue?vue&type=script&lang=js"
export * from "./AddCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8fa503')) {
      api.createRecord('1d8fa503', component.options)
    } else {
      api.reload('1d8fa503', component.options)
    }
    module.hot.accept("./AddCandidate.vue?vue&type=template&id=1d8fa503", function () {
      api.rerender('1d8fa503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/AddCandidate.vue"
export default component.exports